module.exports = __webpack_public_path__ + "img/arrow-sidebar-left.74d0c933.svg";